import { LoadingOutlined } from "@ant-design/icons";
import { useMutation } from "@apollo/client";
import { Spin } from "antd";
import React from "react";
import { FcCameraIdentification } from "react-icons/fc";
import styled from "styled-components";
import { GET_AUTH_USER, UPDATE_PICTURE } from "../app/apollo/index";
import { useAppSelector } from "../app/hooks";
import { device } from "../globalAssets/breakpoints";
import { desktop, mobile } from "../globalAssets/fontsize";
import { userInfo } from "../globalComponents/slice/userDataSlice";
import { NotificationAlert } from "../utils/NotificationAlert";

const Avatar = () => {
  const imageRef: any = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [change, setChange] = React.useState(0);
  const [imageName, setImageName] = React.useState("");
  const [updatePicture] = useMutation(UPDATE_PICTURE);
  const [imageSize, setImageSize] = React.useState<any | undefined>();
  const userDetails = useAppSelector(userInfo);

  const [image, setImage] = React.useState();
  const [notfileType, setnotFileType] = React.useState(false);
  const [notallowImage, setnotAllowImage] = React.useState<boolean | undefined>(
    false
  );
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, textAlign: "center" }} spin />
  );
  console.log("image", image);

  const handleChange = async () => {
    setLoading(true);
    console.log(imageRef.current.files[0]);

    if (
      imageRef?.current?.files[0]?.type === "image/jpeg" ||
      imageRef?.current?.files[0]?.type === "image/jpg" ||
      imageRef?.current?.files[0]?.type === "image/png"
    ) {
      let size = Number(imageRef?.current?.files[0]?.size / 1024);
      //   setImageSize(size);
      console.log("size", size);
      setImageName("");
      if (size > 2048) {
        setImageName(imageRef?.current?.files[0]?.name);
        setLoading(false);
        setnotAllowImage(true);
        return;
      } else {
        setnotAllowImage(false);
        setImageName(imageRef?.current?.files[0]?.name);
        setImage(imageRef?.current?.files[0]);
        try {
          const response = await updatePicture({
            refetchQueries: [
              {
                query: GET_AUTH_USER,
              },
            ],
            variables: {
              picture: imageRef?.current?.files[0],
            },
            // fetchPolicy: "no-cache",
          });

          setLoading(false);
          if (response) {
            setImageName("");
            if (response?.data?.updatePicture?.success) {
              NotificationAlert("success", "", "Picture Uploaded successfully");
            } else if (!response?.data?.updatePicture?.success) {
              NotificationAlert(
                "error",
                "",
                response?.data?.updatePicture?.msg
              );
            }
          }
          console.log("the response", response);
        } catch (e) {
          setLoading(false);
          console.log(e);
          NotificationAlert("error", "Error occured", "Can not upload picture");
        }
      }
    } else {
      setnotFileType(true);
      return;
    }
    // console.log(imageRef.current.files[0].name);

    console.log(imageRef.current.files[0]);
  };
  const handleClick = () => {
    imageRef.current.click();
  };
  return (
    <div onClick={handleClick}>
      <Container>
        <IconContainer>
          <FcCameraIdentification />
        </IconContainer>
        <input
          onChange={handleChange}
          type="file"
          style={{ display: "none" }}
          ref={imageRef}
        />

        {/* <StyledImg src={`data:image/png;base64,${userInfo?.profile_pic}`} /> */}
        {userDetails?.photolink ? (
          <StyledImg
            src={userDetails?.photolink}
            alt={userDetails?.firstname}
          />
        ) : (
          <NameAvatar>
            <h1>{userDetails?.firstname}</h1>
            <h1>{userDetails?.lastname}</h1>
          </NameAvatar>
        )}
      </Container>
      <StyledName>{imageName}</StyledName>
      {loading && <Spin indicator={antIcon} />}
      {notallowImage && <Error>Image is larger than 2mb</Error>}
      {notfileType && <Error>File type not allowed</Error>}
    </div>
  );
};

export default Avatar;

const Container = styled.div`
  width: 80%;
  position: relative;
  cursor: pointer;
  height: 30vh;
  text-align: center;
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
  input {
    height: 100%;
    width: 100%;
  }
`;
const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  /* margin: auto 0; */
  border: none;
  object-fit: fill;
  border-radius: inherit;
`;
const IconContainer = styled.div`
  position: absolute;
  bottom: -1.5vw;
  right: -1.5vw;
  font-size: ${mobile.large};
  background-color: none;
  padding: 1vw;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 0;
  @media ${device.laptop} {
    font-size: ${desktop.large};
  }
`;
const StyledName = styled.h3`
  font-size: ${desktop.small};
  font-weight: 400;
  color: ${(props) => props.theme.primaryColor};
  font-style: italic;
`;
const Error = styled.h3`
  font-style: italic;
  font-size: 14px;
  font-weight: 400;
  color: red;
  @media ${device.laptop} {
    font-size: ${desktop.small};
  }
`;

const NameAvatar = styled.div`
  width: 100%;
  height: 100%;
  /* margin: auto 0; */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.tint};
  & > h1 {
    font-size: 16px;
    color: ${(props) => props.theme.color};
    margin: 0 0.3vw 0 0.3vw;
  }
  @media ${device.laptop} {
    & > h1 {
      font-size: ${desktop.large};
    }
  }
`;
